import { render } from "./RestrictedGifts.vue?vue&type=template&id=7ba8ff32&scoped=true"
import script from "./RestrictedGifts.vue?vue&type=script&lang=js"
export * from "./RestrictedGifts.vue?vue&type=script&lang=js"

import "./RestrictedGifts.vue?vue&type=style&index=0&id=7ba8ff32&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba8ff32"]])

export default __exports__